<template>
  <div :class="$style.wrap">
    <LyTableFilter
      :class="$style.filterWrap"
      :queryData.sync="queryData"
      ref="tableFilterMain"
    />
    <div :class="$style.tableWrap">
      <div class="Table__TopPage">
        共{{ pagerData.total }}条 | 每页{{ pagerData.pageSize }}条 | 共{{
          Math.ceil(pagerData.total / pagerData.pageSize)
        }}页
      </div>
      <LyTable
        :list="list"
        ref="tableMain"
        @pagination="getList"
        :pagerData.sync="pagerData"
        @callback="getList"
      />
      <EditDialog
        :item="current"
        :queueId="item.queue_id"
        @callback="callback"
        :show.sync="editShow"
      />
    </div>
  </div>
</template>

<script>
import { getBackEndUserList } from "./api";
import DepComponent from "./DepComponent";
import EditDialog from "./EditDialog";
export default {
  components: {
    EditDialog,
  },
  props: {
    dep: {
      type: String,
    },
    item: {
      type: Object,
    },
  },
  data() {
    return {
      queryData: {},
      pagerData: {
        total: 0,
        pageIndex: 1,
        pageSize: 20,
      },
      keys: [],
      list: [],
      current: null,
      editShow: false,
    };
  },
  async mounted() {
    await this.getList();
    await this.init();
  },
  computed: {
    filterConfig() {
      return {
        filterData: [
          {
            label: "员工姓名",
            prop: "realname",
            defaultVal: undefined,
            placeholder: "请输入内容",
          },
          {
            label: "工号",
            prop: "username",
            defaultVal: undefined,
            placeholder: "请输入内容",
          },
          {
            label: "组织架构",
            prop: "group_id",
            defaultVal: undefined,
            type: "component",
            component: DepComponent,
          },
          {
            label: "分配状态",
            prop: "allocation_status",
            type: "select",
            defaultVal: undefined,
            options: {
              opts: this.status,
            },
            placeholder: "请选择",
          },
        ],
        buttonsData: {
          buttonsList: [
            {
              text: "查询",
              handle: this.handleSubmit,
              type: "",
              size: "mini",
            },
            {
              text: "清空",
              type: "",
              handle: this.clear,
              size: "mini",
            },
          ],
          config: {
            align: "center",
          },
        },
      };
    },
    tableData() {
      let columns = [];
      for (let key in this.keys) {
        columns.push({
          label: this.keys[key],
          prop: key,
        });
      }
      columns.forEach((item, index) => {
        if (item.prop === "allocation_times") {
          columns[index].format = (val, row) => {
            return row.allocation_status !== 2 ? val : "-";
          };
        }
      });
      return {
        columns,
        operate: {
          operateColumnsLabel: "操作",
          operateColumnsFixed: "right",
          operateColumnsDirection: "row",
          operateColumns: [
            {
              text: "编辑",
              method: ({ row }) => {
                this.edit(row);
              },
            },
          ],
        },
        options: { pagPaginationLayout: "prev, pager, next", border: true },
      };
    },
    status() {
      return [
        { value: "全部", key: 0 },
        { value: "开启", key: 1 },
        { value: "关闭", key: 2 },
      ];
    },
  },
  methods: {
    init() {
      this.$refs["tableFilterMain"].init(this.filterConfig);
      this.$refs["tableMain"].init(this.tableData);
    },
    async getList() {
      this.$refs["tableMain"]?.setTableLoading(true);
      const data = await this.getListData();
      this.$refs["tableMain"]?.setTableLoading(false);
      if (!data) {
        this.list = [];
        return;
      }
      let { list, keys, page, pageSize, allCount } = data;
      this.list = list;
      this.keys = keys;
      this.pagerData = {
        pageIndex: page,
        pageSize: pageSize,
        total: allCount || 0,
      };
    },
    async getListData() {
      let params = {
        page: this.pagerData.pageIndex,
        pageSize: this.pagerData.pageSize,
        ...this.queryData,
        branch: this.item.branch,
        dep_id: this.dep,
        queue_id: this.item.queue_id,
      };
      let res = {};
      try {
        let { data } = await getBackEndUserList(params);
        res = data;
      } catch (error) {
        res.list = [];
        this.$message.error(error);
      }
      return res;
    },
    async handleSubmit() {
      this.pagerData.pageIndex = 1;
      await this.getList();
    },
    clear() {
      this.$refs["tableFilterMain"].clear();
    },
    edit(row) {
      this.current = row;
      this.editShow = true;
    },
    callback() {
      this.getList();
      this.$emit("callback");
    },
  },
};
</script>
<style lang="scss" module>
.wrap {
}
.filterWrap {
  padding: 20px;
  background: #fff;
}
.tableWrap {
  margin-top: 20px;
  padding: 20px;
  background: #fff;
}
</style>